import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Gallery from './pages/Gallery';
import ServiceDetail from './pages/ServiceDetail';
import useDocumentMetadata from './hooks/useDocumentMetadata';

function Home() {
  useDocumentMetadata(
    'BP Anlægsgartner | Din anlægsgartner i Thy & Vestjylland',
    'Søger du en pålidelig anlægsgartner? BP Anlægsgartner tilbyder havedesign, belægning og havepleje i Thy & Vestjylland. Få et uforpligtende tilbud i dag!'
  );

  return (
    <>
      <Hero />
      <Services />
      <Testimonials />
      <About />
      <Contact />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-stone-950 text-stone-100 antialiased selection:bg-emerald-600 selection:text-white">
      {/* Header Navigation */}
      <Header />

      {/* Main Content with Routes */}
      <main>
        <Routes>
          {/* Forside (Home Route) */}
          <Route path="/" element={<Home />} />

          {/* Galleri Underside (Gallery Route) */}
          <Route path="/galleri" element={<Gallery />} />

          {/* Ydelse Detaljeside (Service Detail Route) */}
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
